export default __webpack_public_path__ + "static/media/DSC_0578.7a2adb0f.webp";